<template>
  <div class="container">
    <h1
      class="mt-5 mb-5 center color-primary"
      style="font-family: Comfortaa-Bold"
    >
      Jovool
    </h1>
    <h2>Recuperar senha</h2>
    <div class="card mb-4">
      <div class="card-body">
        <label for="password">Digite seu email</label>
        <input
          v-model="candidates.email"
          class="form-control"
          placeholder="Email"
          type="email"
        />

        <div class="actions">
          <button
            class="mt-3 btn btn-success"
            type="button"
            @click="newPassoword"
          >
            {{ !load ? "Recuperar minha senha" : "" }}
            <div v-show="load" class="spinner-border text-light" role="status">
              <span class="sr-only"></span>
            </div>
          </button>
        </div>

        <div v-if="success" class="alert mt-2 alert-success">
          <span
            >Processo encaminhado com sucesso, confirá o seu email com os passos
            para redefinir sua senha</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { email, required } from "vuelidate/lib/validators";

export default {
  data: () => ({
    success: false,
    load: false,
    candidates: {
      email: "",
    },
  }),
  methods: {
    newPassoword() {
      this.load = true;
      this.$v.candidates.$touch();

      if (!this.$v.candidates.$invalid) {
        axios
          .post("/candidates/password.json", { candidate: this.candidates })
          .then(() => {
            this.load = false;
            this.success = true;
          })
          .catch(() => {
            this.load = false;
            this.success = true;
          });
      } else {
        this.$toast.error("Preencha seu email");
        this.load = false;
      }
    },
  },
  validations: {
    candidates: {
      email: { required, email },
    },
  },
};
</script>
